





















import { defineComponent } from "@vue/composition-api";
import BaseIcon from "@/components/Base/BaseIcon";
import BaseButton from "@/components/BaseButton/BaseButton.vue";

export default defineComponent({
  name: "StepperButtons",
  components: { BaseIcon, BaseButton },
  props: {
    hasNext: { type: Boolean, default: false },
    hasPrev: { type: Boolean, default: false },
    saving: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false },
  },
});
